import type { Buffer } from "../model/buffer";
import { lastLineIndex } from "../model/buffer";
import type { Cursor } from "../model/cursor";
import type { Range } from "../model/range";
import { firstNonBlankCol } from "./basic";

/** `gg`: count指定行（既定は1行目）の最初の非空白文字へ移動する。linewise。 */
export function goToFirstLine(buffer: Buffer, cursor: Cursor, count: number | null): Range {
  const target = count === null ? 0 : count - 1;
  const line = Math.min(Math.max(target, 0), lastLineIndex(buffer));
  return { start: cursor, end: { line, col: firstNonBlankCol(buffer, line) }, kind: "linewise" };
}

/** `G`: count指定行（既定は最終行）の最初の非空白文字へ移動する。linewise。 */
export function goToLastLine(buffer: Buffer, cursor: Cursor, count: number | null): Range {
  const target = count === null ? lastLineIndex(buffer) : count - 1;
  const line = Math.min(Math.max(target, 0), lastLineIndex(buffer));
  return { start: cursor, end: { line, col: firstNonBlankCol(buffer, line) }, kind: "linewise" };
}
